import React from "react"

type InvoicePaymentSummaryProps = {
  totalAmount: number
  totalPaid: number
  remainingAmount: number
}

export function InvoicePaymentSummary({ totalAmount, totalPaid, remainingAmount }: InvoicePaymentSummaryProps) {
  const hasBalance = remainingAmount > 0

  return (
    <div className="border-b border-slate-100 py-6 sm:py-8">
      <p className="mb-3 text-xs font-bold uppercase tracking-widest text-slate-400">Payment Summary</p>

      {/* Mobile: hero balance first */}
      <div className="mb-3 sm:hidden">
        <div
          className={`rounded-xl border p-4 ${hasBalance ? "border-red-100 bg-red-50" : "border-emerald-100 bg-emerald-50"}`}
        >
          <p className={`text-xs ${hasBalance ? "text-red-600" : "text-emerald-600"}`}>Balance Due</p>
          <p
            className={`mt-0.5 text-2xl font-bold tabular-nums ${hasBalance ? "text-red-700" : "text-emerald-700"}`}
          >
            PKR {remainingAmount.toLocaleString()}
          </p>
          <div className="mt-2 flex flex-wrap gap-x-4 text-xs text-slate-600">
            <span>
              Total: <span className="font-semibold tabular-nums">PKR {totalAmount.toLocaleString()}</span>
            </span>
            <span>
              Paid: <span className="font-semibold tabular-nums text-emerald-700">PKR {totalPaid.toLocaleString()}</span>
            </span>
          </div>
        </div>
      </div>

      {/* Desktop / tablet: 3-up strip */}
      <div className="hidden grid-cols-1 gap-2 sm:grid sm:grid-cols-3 sm:gap-4">
        <div className="rounded-xl border border-slate-100 bg-slate-50 p-4 text-center">
          <p className="mb-1 text-xs text-slate-500">Invoice Total</p>
          <p className="text-lg font-bold tabular-nums text-slate-800 sm:text-xl">PKR {totalAmount.toLocaleString()}</p>
        </div>
        <div className="rounded-xl border border-emerald-100 bg-emerald-50 p-4 text-center">
          <p className="mb-1 text-xs text-emerald-600">Total Paid</p>
          <p className="text-lg font-bold tabular-nums text-emerald-700 sm:text-xl">PKR {totalPaid.toLocaleString()}</p>
        </div>
        <div
          className={`rounded-xl border p-4 text-center ${hasBalance ? "border-red-100 bg-red-50" : "border-emerald-100 bg-emerald-50"}`}
        >
          <p className={`mb-1 text-xs ${hasBalance ? "text-red-600" : "text-emerald-600"}`}>Balance Due</p>
          <p
            className={`text-lg font-bold tabular-nums sm:text-xl ${hasBalance ? "text-red-700" : "text-emerald-700"}`}
          >
            PKR {remainingAmount.toLocaleString()}
          </p>
        </div>
      </div>
    </div>
  )
}
